import { lazyWithRetry } from '@shared/utils/lazyWithRetry';

/**
 * Lazy-loaded components compartidos entre rutas y layouts.
 * Centralizar aquí evita duplicar chunks y mantiene un solo punto de carga.
 */
export const LazyUserDetails = lazyWithRetry(() => import('@shared/components/UserDetails'));
export const LazyNotFound = lazyWithRetry(() => import('@shared/components/NotFound'));
